import {
  EarningsInsightType,
  IconDisplayRule,
  SummaryInsightType,
} from '@toggle/toggle';

import {
  useRemoteStorage,
  WHATS_NEW_EARNINGS_TYPES,
  WHATS_NEW_INSIGHT_TYPES,
  WHATS_NEW_PERIOD,
  WHATS_NEW_SELECTED_WATCHLISTS,
  WHATS_NEW_SUMMARY_TYPES,
} from '~/hooks/use-remote-storage';

import { WatchlistSelection } from '../components/watchlist-config-table/WatchlistConfigTable';
import { DEFAULT_WHATS_NEW_PERIOD, InsightsPeriod } from '../types';

export const useWhatsNewSettings = () => {
  const items = useRemoteStorage(state => state.items);

  return {
    selectedWatchlists: items?.[WHATS_NEW_SELECTED_WATCHLISTS] as
      | WatchlistSelection[]
      | undefined,
    period:
      (items?.[WHATS_NEW_PERIOD] as InsightsPeriod) ?? DEFAULT_WHATS_NEW_PERIOD,
    analysisTypes: items?.[WHATS_NEW_INSIGHT_TYPES] as
      | IconDisplayRule[]
      | undefined,
    earningsTypes: items?.[WHATS_NEW_EARNINGS_TYPES] as
      | EarningsInsightType[]
      | undefined,
    summaryTypes: items?.[WHATS_NEW_SUMMARY_TYPES] as
      | SummaryInsightType[]
      | undefined,
  };
};
